import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { DialogService } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { DialogModule } from "primeng/dialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { FileUploadModule } from "primeng/fileupload";
import { CheckboxModule } from "primeng/checkbox";
import { ColorPickerModule } from "primeng/colorpicker";
import { InputMaskModule } from "primeng/inputmask";
import { ListboxModule } from "primeng/listbox";

//
//	Modules
//
import { AppSharedModule } from "../../shared/app-shared.module";
import { ClassroomModule } from "../classroom/classroom.module";
import { PersonSelectorModule } from "../personselector/personselector.module";

//
//	Components
//
import { StudentComponent } from "./components/student.component";
import { OverrideMTAComponent } from "./shared/override-mta/override-mta.component";
import { DisciplineComponent } from "./discipline/discipline.component";
import { DisciplineAddEditBasicComponent } from "./discipline/disciplineaddeditbasic/disciplineaddeditbasic.component";
import { DisciplineAddEditAdvancedComponent } from "./discipline/disciplineaddeditadvanced/disciplineaddeditadvanced.component";
import { DisciplineAddEditCommentComponent } from "./discipline/disciplineaddeditadvanced/disciplineaddeditcomment/disciplineaddeditcomment.component";
import { DisciplinePrintComponent } from "./discipline/disciplineprint/disciplineprint.component";

import { AttendanceComponent } from "./attendance/attendance.component";
import { AttendanceInfoComponent } from "./attendance/attendance-info/attendance-info.component";
import { StudentAddAttendanceComponent } from "./attendance/attendance-info/student-add-attendance/student-add-attendance.component";
import { StudentEditAttendanceComponent } from "./attendance/attendance-info/student-edit-attendance/student-edit-attendance.component";
import { StudentPrintAttendanceComponent } from "./attendance/attendance-info/student-print-attendance/student-print-attendance.component";
import { AttendanceHistoryComponent } from "./attendance/attendance-history/attendance-history.component";
import { TimescanInfoComponent } from "./attendance/timescan-info/timescan-info.component";
import { StudentViewAttendanceHistoryComponent } from "./attendance/attendance-history/student-view-attendance-history/student-view-attendance-history.component";
import { GuardianNotificationComponent } from "./guardiannotification/guardiannotification.component";
import { MTAHistoryComponent } from "./mtahistory/mtahistory.component";
import { StudentHeaderComponent } from "./studentheader/studentheader.component";
import { StudentMeritComponent } from "./student-merit/student-merit.component";
import { StudentAddMeritComponent } from "./student-merit/student-add-merit/student-add-merit.component";
import { StudentEditMeritComponent } from "./student-merit/student-edit-merit/student-edit-merit.component";
import { StudentAlertsComponent } from "./student-alerts/student-alerts.component";
import { StudentAlertsTableComponent } from "./student-alerts/student-alerts-table/student-alerts-table.component";
import { StudentClassAttendanceComponent } from "./student-class-attendance/student-class-attendance.component";
import { ClassAttendanceTableComponent } from "./student-class-attendance/class-attendance-table/class-attendance-table.component";
import { StudentEditClassAttendanceComponent } from "./student-class-attendance/class-attendance-table/student-edit-class-attendance/student-edit-class-attendance.component";
import { ClassAttendanceHistoryTableComponent } from "./student-class-attendance/class-attendance-history-table/class-attendance-history-table.component";
import { ViewClassAttendanceHistoryComponent } from "./student-class-attendance/class-attendance-history-table/view-class-attendance-history/view-class-attendance-history.component";

import { ReportFileTypeDialogComponent } from "./shared/report-file-type-dialog/report-file-type-dialog.component";

import { StudentScanHistoryComponent } from "./student-scan-history/student-scan-history.component";
import { StudentScanViewDetailsComponent } from "./student-scan-history/student-scan-view-details/student-scan-view-details.component";
import { StudentScanViewManualComponent } from "./student-scan-history/student-scan-view-manual/student-scan-view-manual.component";
import { StudentScanViewAlertsComponent } from "./student-scan-history/student-scan-view-alerts/student-scan-view-alerts.component";

import { StudentDemographicsComponent } from "./student-demographics/student-demographics.component";
import { DemographicsGuardianTableComponent } from "./student-demographics/demographics-guardian-table/demographics-guardian-table.component";
import { StudentAddGuardianComponent } from "./student-demographics/demographics-guardian-table/student-add-guardian/student-add-guardian.component";
import { StudentEditGuardianComponent } from "./student-demographics/demographics-guardian-table/student-edit-guardian/student-edit-guardian.component";

import { StudentScheduleComponent } from "./student-schedule/student-schedule.component";

import { StudentReleaseComponent } from "./student-release/student-release.component";
import { StudentAddReleaseComponent } from "./student-release/student-add-release/student-add-release.component";
import { StudentEditReleaseComponent } from "./student-release/student-edit-release/student-edit-release.component";
import { ReleaseGuardianTableComponent } from "./student-release/shared/release-guardian-table/release-guardian-table.component";

import { StudentFinesDebtsComponent } from "./student-fines-debts/student-fines-debts.component";
import { StudentAddFineComponent } from "./student-fines-debts/student-add-fine/student-add-fine.component";
import { StudentAdjustFineComponent } from "./student-fines-debts/student-adjust-fine/student-adjust-fine.component";
import { StudentFineDetailsComponent } from "./student-fines-debts/student-fine-details/student-fine-details.component";
import { StudentPayFineComponent } from "./student-fines-debts/student-pay-fine/student-pay-fine.component";
import { StudentFineRefundComponent } from "./student-fines-debts/student-fine-refund/student-fine-refund.component";

import { StudentLockersComponent } from "./student-lockers/student-lockers.component";
import { StudentAddLockerComponent } from "./student-lockers/student-add-locker/student-add-locker.component";
import { StudentEditLockerComponent } from "./student-lockers/student-edit-locker/student-edit-locker.component";
import { StudentRemoveLockerComponent } from "./student-lockers/student-remove-locker/student-remove-locker.component";

import { StudentGuidanceComponent } from "./student-guidance/student-guidance.component";
import { StudentAddLogComponent } from "./student-guidance/student-add-log/student-add-log.component";
import { StudentEditLogComponent } from "./student-guidance/student-edit-log/student-edit-log.component";

//
//	Services
//
import { DataService_Attendance } from "./attendance/shared/data.service";
import { AddPointService } from "../classroom/classroomAttendance/point/addPoints/addPoints.service";
import { DataService_guardiannotification } from "./guardiannotification/shared/data.service";
import { DataService_discipline } from "./discipline/shared/data.service";
import { DataService_MTA } from "./mtahistory/shared/data.service";
import { DataService_Student_PBIS } from "./student-merit/shared/data.service";
import { DataService_Student_Alerts } from "./student-alerts/shared/data.service";
import { DataService_Student_Class_Attendance } from "./student-class-attendance/shared/data.service";
import { DataService_Student_Scan_History } from "./student-scan-history/shared/data.service";
import { DataService_Student_Demographics } from "./student-demographics/shared/data.service";
import { DataService_StudentSchedule } from "./student-schedule/shared/data.service";
import { DataService_StudentRelease } from "./student-release/shared/data.service";
import { DataService_StudentLocker } from "./student-lockers/shared/data.service";
import { DataService_StudentGuidance } from "./student-guidance/shared/data.service";
import { DataService_StudentFinesDebts } from "./student-fines-debts/shared/data.service";
import { ManualFineTableComponent } from "./student-fines-debts/student-pay-fine/manual-fine-table/manual-fine-table.component";
import { FineHistoryTableComponent } from "./student-fines-debts/student-fine-details/fine-history-table/fine-history-table.component";
import { StudentPBISComponent } from "./student-pbis/student-pbis.component";
import { StudentPBISAddComponent } from "./student-pbis/student-pbisperson-mode/student-pbis-add/student-pbis-add.component";
import { StudentPBISRedeemComponent } from "./student-pbis/student-pbisperson-mode/student-pbis-redeem/student-pbis-redeem.component";
import { DataService_Student_Point } from "./student-pbis/shared/data.service";
import { StudentMealsComponent } from "./student-meals/student-meals.component";
import { DataService_StudentMeals } from "./student-meals/shared/data.service";
import { AddMealComponent } from "./student-meals/add-meal/add-meal.component";
import { MealDepositComponent } from "./student-meals/meal-deposit/meal-deposit.component";
import { DemographicsService } from "./shared/Demographics.service";
import { StudentPBISPersonModeComponent } from "./student-pbis/student-pbisperson-mode/student-pbisperson-mode.component";
import { StudentPBISGroupModeComponent } from "./student-pbis/student-pbisgroup-mode/student-pbisgroup-mode.component";
import { GroupAddPointComponent } from "./student-pbis/student-pbisgroup-mode/group-add-point/group-add-point.component";
import { GroupRedeemPointComponent } from "./student-pbis/student-pbisgroup-mode/group-redeem-point/group-redeem-point.component";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { GroupPrintPointOptionsComponent } from "./student-pbis/student-pbisgroup-mode/group-print-point-options/group-print-point-options.component";
import { StudentDigitalIdRegistrationComponent } from "./student-digital-id-registration/student-digital-id-registration.component";
import { DigitalIdManualModeComponent } from "./student-digital-id-registration/digital-id-manual-mode/digital-id-manual-mode.component";
import { DigitalIdBatchModeComponent } from "./student-digital-id-registration/digital-id-batch-mode/digital-id-batch-mode.component";
import { DigitalIdEmailLogComponent } from "./student-digital-id-registration/digital-id-email-log/digital-id-email-log.component";
import { DataService_Student_DigitalID } from "./student-digital-id-registration/shared/data.service";
import { ManualStudentTableComponent } from "./student-digital-id-registration/digital-id-manual-mode/manual-student-table/manual-student-table.component";
import { ManualEmailTableComponent } from "./student-digital-id-registration/digital-id-manual-mode/manual-email-table/manual-email-table.component";
import { ExportDigitalIDComponent } from "./student-digital-id-registration/digital-id-batch-mode/export-digital-id/export-digital-id.component";
import { DigitalIdBatchImportTableComponent } from "./student-digital-id-registration/digital-id-batch-mode/digital-id-batch-import-table/digital-id-batch-import-table.component";
import { DigitalIdBatchImportComponent } from "./student-digital-id-registration/digital-id-batch-mode/digital-id-batch-import/digital-id-batch-import.component";
import { DigitalIdDownloadComponent } from "./student-digital-id-registration/digital-id-batch-mode/digital-id-download/digital-id-download.component";
import { StudentScanViewRemindersComponent } from "./student-scan-history/student-scan-view-reminders/student-scan-view-reminders.component";
import { DemographicsCurrentRemindersTableComponent } from "./student-demographics/demographics-current-reminders-table/demographics-current-reminders-table.component";
import { DigitalIdActivationInfoComponent } from "./student-digital-id-registration/digital-id-activation-info/digital-id-activation-info.component";
import { StudentHallSweepComponent } from "./student-hall-sweep/student-hall-sweep.component";
import { DataService_StudentHallSweep } from "./student-hall-sweep/shared/data.service";
import { DigitalIdPrintQrCodesComponent } from "./student-digital-id-registration/digital-id-print-qr-codes/digital-id-print-qr-codes.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { StudentScanViewBlockListComponent } from "./student-scan-history/student-scan-view-block-list/student-scan-view-block-list.component";
import { DemographicsCurrentBlockListTableComponent } from "./student-demographics/demographics-current-block-list-table/demographics-current-block-list-table.component";

@NgModule({
	declarations: [
		StudentComponent,
		DisciplineComponent,
		DisciplineAddEditBasicComponent,
		DisciplineAddEditAdvancedComponent,
		DisciplinePrintComponent,
		DisciplineAddEditCommentComponent,
		AttendanceComponent,
		AttendanceInfoComponent,
		StudentAddAttendanceComponent,
		StudentEditAttendanceComponent,
		StudentPrintAttendanceComponent,
		AttendanceHistoryComponent,
		TimescanInfoComponent,
		StudentViewAttendanceHistoryComponent,
		MTAHistoryComponent,
		StudentHeaderComponent,
		GuardianNotificationComponent,
		OverrideMTAComponent,
		StudentMeritComponent,
		StudentAddMeritComponent,
		StudentEditMeritComponent,
		StudentAlertsComponent,
		StudentAlertsTableComponent,
		StudentClassAttendanceComponent,
		ClassAttendanceTableComponent,
		StudentEditClassAttendanceComponent,
		ClassAttendanceHistoryTableComponent,
		ViewClassAttendanceHistoryComponent,
		ReportFileTypeDialogComponent,
		StudentScanHistoryComponent,
		StudentScanViewDetailsComponent,
		StudentScanViewManualComponent,
		StudentScanViewAlertsComponent,
		StudentDemographicsComponent,
		DemographicsGuardianTableComponent,
		StudentEditGuardianComponent,
		StudentAddGuardianComponent,
		StudentScheduleComponent,
		StudentReleaseComponent,
		StudentAddReleaseComponent,
		StudentEditReleaseComponent,
		ReleaseGuardianTableComponent,
		StudentFinesDebtsComponent,
		StudentAddFineComponent,
		StudentAdjustFineComponent,
		StudentFineDetailsComponent,
		StudentPayFineComponent,
		StudentFineRefundComponent,
		StudentLockersComponent,
		StudentAddLockerComponent,
		StudentEditLockerComponent,
		StudentRemoveLockerComponent,
		StudentGuidanceComponent,
		StudentAddLogComponent,
		StudentEditLogComponent,
		ManualFineTableComponent,
		FineHistoryTableComponent,
		StudentPBISComponent,
		StudentPBISAddComponent,
		StudentPBISRedeemComponent,
		StudentMealsComponent,
		AddMealComponent,
		MealDepositComponent,
		StudentPBISPersonModeComponent,
		StudentPBISGroupModeComponent,
		GroupAddPointComponent,
		GroupRedeemPointComponent,
		GroupPrintPointOptionsComponent,
		StudentDigitalIdRegistrationComponent,
		DigitalIdManualModeComponent,
		DigitalIdBatchModeComponent,
		DigitalIdEmailLogComponent,
		ManualStudentTableComponent,
		ManualEmailTableComponent,
		ExportDigitalIDComponent,
		DigitalIdBatchImportTableComponent,
		DigitalIdBatchImportComponent,
		DigitalIdDownloadComponent,
		StudentScanViewRemindersComponent,
		DemographicsCurrentRemindersTableComponent,
		DigitalIdActivationInfoComponent,
		StudentHallSweepComponent,
		DigitalIdPrintQrCodesComponent,
		StudentScanViewBlockListComponent,
		DemographicsCurrentBlockListTableComponent,
	],

	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		RouterModule,
		PersonSelectorModule,
		DynamicDialogModule,
		TableModule,
		CheckboxModule,
		ClassroomModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		FileUploadModule,
		ColorPickerModule,
		InputMaskModule,
		SchoolselectorModule,
		ListboxModule,
		ProgressSpinnerModule,
	],

	exports: [StudentComponent],

	providers: [
		DataService_Attendance,
		ConfirmationService,
		DialogService,
		AddPointService,
		DataService_guardiannotification,
		DataService_discipline,
		DataService_MTA,
		DataService_Student_PBIS,
		DataService_Student_Alerts,
		DataService_Student_Class_Attendance,
		DataService_Student_Scan_History,
		DataService_Student_Demographics,
		DataService_StudentSchedule,
		DataService_StudentRelease,
		DataService_StudentLocker,
		DataService_StudentGuidance,
		DataService_StudentFinesDebts,
		DataService_Student_Point,
		DataService_StudentMeals,
		DemographicsService,
		DemographicsService,
		DataService_Student_DigitalID,
		DataService_StudentHallSweep,
	],
})
export class StudentModule {}
